import axios from 'axios';

const client = axios.create();

client.interceptors.response.use((res) => res, (err) => {
  if (err.response?.status === 401) {
    alert('A sua sessão expirou. Faça o login novamente.');
    window.location.href = '/admin';
    return;
  }
  if (err.response === undefined) {
    alert('Não é possível se conectar ao servidor.');
  }
  throw err;
});

export default client;
